class AgentEventEmitter extends EventTarget {
  static instance = null;

  static getInstance() {
    if (!AgentEventEmitter.instance) {
      AgentEventEmitter.instance = new AgentEventEmitter();
    }
    return AgentEventEmitter.instance;
  }

  emitRefresh() {
    this.dispatchEvent(new CustomEvent('refresh-agents'));
  }

  onRefresh(callback) {
    this.addEventListener('refresh-agents', callback);
    return () => this.removeEventListener('refresh-agents', callback);
  }
}

export const agentEventEmitter = AgentEventEmitter.getInstance();